
import { authFetch } from "./api"; 

export async function getCustomerEmail(customerId) {
    try {
      console.log("customerId:", customerId);
  
      if (!customerId || customerId === 0) {
        return "Invalid customerId";
      }
  
      const data = await authFetch(`/customers/${customerId}`);
    
      if (!data?.email) {
        return "Email not found";
      }
  
      return data.email;
    } catch (error) {
      console.error("Error fetching customer email:", error);
      return "Error fetching data";
    }
  }
